// Generated by scripts/build-ui-icons.mjs.
export { Car as default } from "../ui/glyphs-2";
